export enum FileUploaderVariant {
  dropzone = 'dropzone',
  compact = 'compact',
}